import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import NotificationsWrapper from '../components/NotificationsWrapper'

export default connect(
  (state: ApplicationState) => {
    const notifications = {
      notifications: state.notifications,
    }
    return Object.assign(notifications)
  },
  {},
)(NotificationsWrapper)
